export const Amex = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="20"
    viewBox="0 0 29 20"
    fill="none"
  >
    <rect x="0.5" y="0.5" width="27.3333" height="19" rx="3.5" fill="#1F72CD" />
    <rect
      x="0.5"
      y="0.5"
      width="27.3333"
      height="19"
      rx="3.5"
      stroke="#F2F4F7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.07964 7.08325L2.42871 13.1222H5.60224L5.99567 12.1593H6.89495L7.28837 13.1222H10.7815V12.3873L11.0928 13.1222H12.8997L13.211 12.3718V13.1222H20.4758L21.3592 12.1843L22.1864 13.1222L25.9177 13.13L23.2584 10.1196L25.9177 7.08325H22.2442L21.3843 8.00378L20.5832 7.08325H12.68L12.0014 8.64196L11.3068 7.08325H8.13991V7.79313L7.78761 7.08325H5.07964ZM5.6937 7.94079H7.24062L8.99898 12.0358V7.94079H10.6936L12.0517 10.8769L13.3034 7.94079H14.9895V12.2741H13.9635L13.9552 8.87855L12.4594 12.2741H11.5416L10.0375 8.87855V12.2741H7.92682L7.52668 11.3027H5.36486L4.96555 12.2733H3.83468L5.6937 7.94079ZM20.1 7.94079H15.9282V12.2716H20.0354L21.3592 10.8363L22.6352 12.2716H23.969L22.0303 10.1187L23.969 7.94079H22.693L21.3759 9.35961L20.1 7.94079ZM6.44622 8.67397L5.73399 10.4046H7.15763L6.44622 8.67397ZM16.9584 9.62906V8.83801V8.83725H19.5615L20.6973 10.1023L19.5111 11.3743H16.9584V10.5107H19.2343V9.62906H16.9584Z"
      fill="white"
    />
  </svg>
);
